import type {
  CompanyCreationData,
  CreateCompanyCommandData,
} from '@festina/legalentity-general-types/legalentity'
import { CompaniesService } from '@festina/legalentity-general-types/legalentity/services/CompaniesService'
import { useFestinaMutation } from '@festina-life/authentication'

type Props = {
  tenantId: string
}

const method = CompaniesService.legalEntitiesCompanyServicePostEntity

type TriggerProps = CreateCompanyCommandData & {
  identificationCreationData: CompanyCreationData['identificationCreationData']
}

export const useCreateCompanyCommand = ({ tenantId }: Props) =>
  useFestinaMutation({
    component: 'legalEntity',
    roles: CompaniesService.legalEntitiesCompanyServicePostEntity_roles,
    isScenario: false,
    mutateFunction: async ({
      identificationCreationData,
      ...createCompanyCommandData
    }: TriggerProps) => {
      await method({
        xTenantId: tenantId,
        requestBody: {
          _type: 'CompanyCreationData',
          identificationCreationData,
          createCompanyCommandData,
        },
      })
    },
  })
